<template>
  <!-- Gestion de l'ordre -->
  <v-menu ransition="slide-x-transition" bottom offset-y>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn raised icon class="mx-2 p-4" color="#e6057d">
            <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              {{getCurrentSortingTypeIcon}}
            </v-icon>
          </v-btn>
        </template>
        <span v-html="$i18n.t('sortingMenu.tooltip')"/>
      </v-tooltip>
    </template>
    <v-card>
      <!-- Bouton de gestion du type d'ordre (i.e par date, vues, alpha) -->
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-around;
        "
      >
        <v-list class="mx-2">
          <v-list-item-group
            v-model="sorting.sortVideoType"
            mandatory
            color="#e6057d"
          >
            <v-list-item
              v-for="(item, index) in sorting.sortVideoTypeList"
              :key="index"
              :disabled="item.type == 'sort-pertinence' && !isFilterTextOn"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-divider vertical></v-divider>
        <!-- Bouton de gestion de la direction de l'ordre (Ascendant, Descendant) -->
        <v-btn-toggle
          v-model="sorting.sortVideoDirection"
          mandatory
          color="#e6057d"
          dense
          group
          class="text-center mx-2"
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          "
        >
          <template
            v-for="(direction, directionIdx) in sorting.sortVideoDirectionList"
          >
            <v-tooltip :key="directionIdx" right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="getCurrentSortingType == 'sort-pertinence' && isFilterTextOn" v-bind="attrs" v-on="on" icon class="mx-auto mt-2">
                  <v-icon>{{ direction.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ direction.tooltip }}</span>
            </v-tooltip>
          </template>
        </v-btn-toggle>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: "sortingMenu",
  props: {
    filters: {Object, default : null},
    localStorageSortingKey: {
      type: String,
      default: "localStorage_sorting",
    },
  },
  /**********************************
   * DATA
   **********************************/
  computed:{
    getCurrentSortingType() {
      return this.sorting.sortVideoTypeList[this.sorting.sortVideoType].type;
    },
    getCurrentSortingTypeIcon(){
      return this.sorting.sortVideoTypeList[this.sorting.sortVideoType].icon;
    },
    isFilterTextOn(){
      return this.filters && this.filters.text != "";
    },
  },
  data: function () {
    return {
      sorting: {
        sortVideoType: 1,
        sortVideoTypeList: [
          {
            title: this.$i18n.t("sortingMenu.pertinence"),
            type: "sort-pertinence",
            icon: "fas fa-solid fa-magnifying-glass-chart",
          },
          {
            title: this.$i18n.t("sortingMenu.date"),
            type: "sort-date",
            icon: "fas fa-clock",
          },
          {
            title: this.$i18n.t("sortingMenu.alpha"),
            type: "sort-alpha",
            icon: "fas fa-sort-alpha-down",
          },
          {
            title: this.$i18n.t("sortingMenu.view"),
            type: "sort-view",
            icon: "fas fa-eye",
          },
        ],
        sortVideoDirection: 1,
        sortVideoDirectionList: [
          {
            icon: "fas fa-sort-asc",
            direction: "ASC",
            tooltip: this.$i18n.t("sortingMenu.order.asc"),
          },
          {
            icon: "fas fa-sort-desc",
            direction: "DESC",
            tooltip: this.$i18n.t("sortingMenu.order.desc"),
          },
        ],
      },
    };
  },
  mounted() {
    this.loadSortingStorage();
  },
  /**********************************
   * WATCH
   **********************************/
  watch: {
    "isFilterTextOn" : function(oldValue, newValue){
      if (oldValue == newValue) return;
      this.loadSortingStorage();
    },
    // Vérification sur changement du type d'ordre (par date,vues,alphabet,etc...)
    "sorting.sortVideoType": function (oldType, newType) {
      if (oldType == newType) return;
      this.onSortingChange();
    },
    // Vérification sur changement de la direction de l'ordre (Ascendant,Descendant)
    "sorting.sortVideoDirection": function (oldDirection, newDirection) {
      if (oldDirection == newDirection) return;
      this.onSortingChange();
    },
  },
  methods: {
    saveSortingStorage(data) {
      localStorage[this.localStorageSortingKey] = JSON.stringify(data);
    },
    loadSortingStorage() {
      let sortingLoaded = localStorage[this.localStorageSortingKey];
      if(!sortingLoaded){
        sortingLoaded = this.sorting;
        this.saveSortingStorage(sortingLoaded);
      }
      this.sorting = JSON.parse(localStorage[this.localStorageSortingKey]);
      if(!this.isFilterTextOn && this.sorting.sortVideoType == 0) this.$set(this.sorting,'sortVideoType',1);
      if(this.isFilterTextOn && this.sorting.sortVideoType != 0) this.$set(this.sorting,'sortVideoType',0);
    },
    // Méthode pour gèrer le changement de paramètres sur la sélection des vidéos
    onSortingChange() {
      this.$emit("sortingParameters", this.sorting);
      this.saveSortingStorage(this.sorting);
    },
  },
};
</script>